export const NotificationBell = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill="url(#paint0_linear_18338_6450)"
        fillOpacity="0.16"
      />
      <path
        d="M23.498 22H8.49805V20.5H9.24805V15.2736C9.24805 11.5326 12.2701 8.5 15.998 8.5C19.726 8.5 22.748 11.5326 22.748 15.2736V20.5H23.498V22ZM14.123 22.75H17.873C17.873 23.7855 17.0336 24.625 15.998 24.625C14.9625 24.625 14.123 23.7855 14.123 22.75Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_18338_6450"
          x1="16"
          y1="0"
          x2="16"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  );
};
